// extracted by mini-css-extract-plugin
module.exports = {"adminMenu":"AdminMenu_adminMenu__3X4sH","menuItems":"AdminMenu_menuItems__1ZCWE","menuItem":"AdminMenu_menuItem__29oR7","active":"AdminMenu_active__aA2dh"};